export const GENERAL_REPORT__ACL_OBJECTS = [
    'CustomReportComponent',
    'CustomReportDetailComponent',
    // general_report_result is used inside CustomReportDetailComponent
];
